import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faCog, faSignOutAlt, faUserCircle } from '@fortawesome/free-solid-svg-icons';
import Avatar from '../../common/Avatar';
import paths from '../../../routes/paths';
import { useAuth } from '../../../contexts/AuthContext';
import { useProfileImage } from '../../../hooks/useProfileImage';

// Componente wrapper para el Avatar que se actualiza independientemente
const DynamicAvatar = ({ user }) => {
  const { imageKey, imageSrc } = useProfileImage(user);
  
  if (!user) return null;
  
  return (
    <Avatar 
      key={`dynamic-avatar-${user.id}-${imageKey}`}
      src={imageSrc} 
    />
  );
};

const ProfileDropdown = () => {
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Error durante logout:', error);
      // En caso de error, forzar la navegación al login
      navigate('/login');
    }
  };

  // Si no hay usuario, no mostrar el dropdown
  if (!user) {
    return null;
  }

  return (
    <Dropdown navbar={true} as="li">
      <Dropdown.Toggle
        bsPrefix="toggle"
        as={Link}
        to="#!"
        className="pe-0 ps-2 nav-link"
      >
         <DynamicAvatar user={user} />
      </Dropdown.Toggle>

      <Dropdown.Menu className="dropdown-caret dropdown-menu-card dropdown-menu-end">
        <div className="bg-white rounded-2 py-2 dark__bg-1000">
          {/* Información del usuario */}
          <div className="px-3 py-2 border-bottom">
            <h6 className="mb-0">{user.fullName || user.username}</h6>
            <small className="text-muted">@{user.username}</small>
            {isAdmin() && (
              <div>
                <small className="badge bg-primary ms-1">Admin</small>
              </div>
            )}
          </div>

          {/* Opciones del menú */}
          <Dropdown.Item as={Link} to={paths.userProfile}>
            <FontAwesomeIcon icon={faUser} className="me-2" />
            Perfil y cuenta
          </Dropdown.Item>
          
          <Dropdown.Divider />
          
          <Dropdown.Item as={Link} to={paths.userSettings}>
            <FontAwesomeIcon icon={faCog} className="me-2" />
            Configuración
          </Dropdown.Item>
          
          {isAdmin() && (
            <>
              <Dropdown.Item as={Link} to="/admin">
                <FontAwesomeIcon icon={faUserCircle} className="me-2" />
                Panel de Admin
              </Dropdown.Item>
              <Dropdown.Divider />
            </>
          )}
          
          <Dropdown.Item onClick={handleLogout} className="text-danger">
            <FontAwesomeIcon icon={faSignOutAlt} className="me-2" />
            Cerrar Sesión
          </Dropdown.Item>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ProfileDropdown;
